import React from "react";
import { ChevronRight } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import Text from "@/components/ui/text";
import Collapse from "@/components/ui/collapse";
import { cn } from "@/utils/utils";
import { isEmpty } from "lodash";

interface Props {
  label: string;
  citation?: string;
}

const MismatchSource: React.FC<Props> = ({ label, citation }) => {
  if (isEmpty(citation)) return null;

  return (
    <Collapse
      trigger={(isOpen) => (
        <div className="flex items-center gap-[2px] mb-2">
          <IconContainer
            color="secondary"
            className={cn(
              "transition-transform duration-200",
              isOpen ? "rotate-90" : ""
            )}
          >
            <ChevronRight />
          </IconContainer>
          <Text variant="bodySecondary">{label}</Text>
        </div>
      )}
    >
      <Text className="px-2 max-h-[14rem] overflow-y-auto italic">
        {citation}
      </Text>
    </Collapse>
  );
};

export default MismatchSource;
